export const login = {
  login: '登入',
  logout: '登出',

  activeAccount: '首次啓動',
  loading: '正在登入',
}
